import { axios } from "./AxiosInstance";

export const submitQuestionPaper = async (payload: any) => {
  // Check if payload is FormData (contains file uploads)
  if (payload instanceof FormData) {
    // For FormData, let axios automatically set Content-Type with boundary
    // Do NOT manually set Content-Type header
    const { data } = await axios.post("/user-test/user-qpaper/submit", payload);
    return data;
  } else {
    // For JSON payload (backward compatibility)
    const { data } = await axios.post("/user-test/user-qpaper/submit", payload);
    return data;
  }
};


export type BulkUploadItem = { studentId: string; questionId: string; file: File };
export type BulkUploadResult = { index: number; filename: string; url: string };

const getBackendBaseUrl = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/:3000$/, ":9000").replace(/\/+$/, "");
  }
  return "";
};

export async function uploadManyStudentAnswers(items: BulkUploadItem[]): Promise<BulkUploadResult[]> {
  const form = new FormData();
  // Keep order stable to match index mapping on server
  for (const it of items) form.append("studentIds", it.studentId);
  for (const it of items) form.append("questionIds", it.questionId);
  for (const it of items) form.append("files", it.file);

  const res = await fetch(`${getBackendBaseUrl()}/api/question/answers`, { method: "POST", body: form, credentials: "include" });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    console.error("Upload error", res.status, txt);
    throw new Error(`Upload failed ${res.status}: ${txt}`);
  }
  const data = (await res.json()) as { uploaded: BulkUploadResult[] };
  return data.uploaded || [];
}

// export async function submitQuestionPaper(payload: any) {
//   const res = await fetch(`${getBackendBaseUrl()}/api/user/questionpaper/submit`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     credentials: "include",
//     body: JSON.stringify(payload),
//   });
//   if (!res.ok) {
//     const msg = await res.text().catch(() => "");
//     throw new Error(msg || "Submit failed");
//   }
//   return res.json();
// }



export const retestSubmitQuestionPaper = async (payload: any) => {
  try {
    const { data } = await axios.post("/user-qpaper/retest", payload);
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Retest failed");
  } 
};

export const getUserQuestionPaperByStudentSchoolPaperID = async ({
  qpaperId,
  studentId,
  schoolId,
}: {
  qpaperId: string;
  studentId: string;
  schoolId: string;
}) => {
  try {
    const { data } = await axios.post(
      `/user-qpaper/getUserQuestionPaperByStudentSchoolPaperID`,
      { qpaperId, studentId, schoolId }
    );
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Fetch failed");
  }
};

export const getUserQuestionPaperById = async (id: string) => {
  try {
    const { data } = await axios.get(`/user-qpaper/${id}`);
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Not found");
  }
};

// For student: Get all question papers
export const fetchStudentQuestionPapers = async () => {
  try {
    const { data } = await axios.get("/question-papers/student");
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Failed to load papers");
  }
};

export const saveQuestionPaperProgress = async (payload: any) => {
  try {
    const { data } = await axios.post("/user-qpaper/save-progress", payload);
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Progress save failed");
  }
};


